import { withTranslation } from "react-i18next";
import DepartureDate from './DepartureDate';
import * as tourTicketActions from './../../../../../../../actions/tourTicketAction';
import { connect } from "react-redux";

const mapStateToProps = state => {
    return {
        tourTicket: state.tourTicketReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllTickets: (params) => dispatch(tourTicketActions.getAllTickets(params)),
        getAllTicketsById: (id) => dispatch(tourTicketActions.getAllTicketsById(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(DepartureDate));
